package com.macrofocus.high_d

import com.macrofocus.high_d.tablelens.DefaultTableLensController
import com.macrofocus.high_d.tablelens.DefaultTableLensView
import com.macrofocus.high_d.tablelens.TableLensModel
import react.FC
import react.Props

@JsExport
external interface TableLensProps : Props {
    var model: TableLensModel<Int, String>?
}

@JsExport
val TableLens = FC<TableLensProps> { props ->
//    val view = useMemo(props.model) {
        val view = DefaultTableLensView<Int, String>()
        view.model = props.model
        DefaultTableLensController<Int, String>(view)
        view
//    }
    view.component.nativeComponent()
}
